import React from 'react';
import { useParameterizedQuery } from 'react-fetching-library';
import { Portal, Modal, Card, CardContent, Button, Typography, Stack, Box } from '@mui/material';
import { refreshEmployeeAgreementAction, refreshAgreementData, refreshAnnexData } from '../../../../../../services/request';

import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


export default function ConfirmRefreshAgreementModal ({ handleClose, order, application, type = 'agreement' }) {
  const { query } = useParameterizedQuery(refreshEmployeeAgreementAction);
  const { query: queryAnnex } = useParameterizedQuery(refreshAnnexData);

  const handleClick = async () => {
    const { error, loading } = await query(application.id);
    if (!error && !loading) {
      handleClose();
      toast.success('Umowa została zaktualizowana');
    }

    if (error) {
      toast.error('Nie udało się zaktualizować umowy');
    }
  };

  const handleClickAnnex = async () => {
    const { error, loading } = await queryAnnex(order.id);
    if (!error && !loading) {
      handleClose();
      toast.success('Aneks została zaktualizowana');
    }

    if (error) {
      toast.error('Nie udało się zaktualizować aneksu');
    }
  };

  return (
    <Portal>
      <Modal open={true} onClose={handleClose}>
        <Card sx={{ ...style, width: 450 }}>
          <CardContent>
            <Typography align="center">
              {type === 'agreement' ? 'Czy na pewno chcesz zaktualizować umowę bez wystawienia aneksu? Tej czynności nie można cofnąć' : 'Czy na pewno chcesz zaktualizować aneks?'}
            </Typography>
            <Box height={40} />
            <Stack direction="row" justifyContent="space-between">
              <Button variant="outlined" sx={{ flex: 0.45 }} onClick={handleClose}>Anuluj</Button>
              <Button variant="contained" sx={{ flex: 0.45 }} onClick={type === 'agreement' ? handleClick : handleClickAnnex}>Aktualizuj</Button>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
